import { LabelledDateRange } from '@teetsh/app/src/types/zone';
import { Periode } from '@teetsh/app/src/types/programmations';
import isWithinInterval from '@teetsh/app/src/utils/time/isWithinInterval';
import startOfDay from '@teetsh/app/src/utils/time/startOfDay';
import endOfDay from '@teetsh/app/src/utils/time/endOfDay';

export interface PeriodeWithWeeks {
  periode: LabelledDateRange;
  weeks: Periode[];
}

// startOfDay and endOfDay are used because of inconsistencies among dates coming from the server
// schoolyear periodes are deserizalized using the user timezone (ex: Indian/Reunion)
// weeks are deserizalized using UTC timezone, so it might be off by a few hours depending on the timezone
export const doesWeekBelongsToPeriode = (
  week: Periode,
  start: Date,
  end: Date,
) =>
  week.startDate &&
  week.endDate &&
  isWithinInterval(week.startDate, { start: startOfDay(start), end }) &&
  isWithinInterval(week.endDate, { start, end: endOfDay(end) });

export function groupWeeksByPeriode(
  weeks: Periode[],
  periodes: LabelledDateRange[] = [],
): {
  weeksByPeriodes?: PeriodeWithWeeks[];
  otherWeeks?: Periode[];
} {
  const weeksByPeriodes = periodes
    .filter(p => p.from && p.to)
    .map(p => ({
      periode: p,
      weeks: weeks.filter(w => doesWeekBelongsToPeriode(w, p.from!, p.to!)),
    }))
    .filter(p => p.weeks.length);

  return {
    ...(weeksByPeriodes.length && { weeksByPeriodes }),
    otherWeeks: weeks.filter(
      w => !weeksByPeriodes.find(p => p.weeks.includes(w)),
    ),
  };
}
